export const MAX_CHARS = 200;